module.exports = __webpack_public_path__ + "img/21_31.96558d80.png";